import $t from '@cloudpivot/common/src/utils/lang';
const optionsMap = {
    /**
     * 必填条件标识
     */
    conditonOptions: [
        {
            text: "==",
            rule: 1
        },
        {
            text: ">",
            rule: 2
        },
        {
            text: "<",
            rule: 3
        },
        {
            text: ">=",
            rule: 4
        },
        {
            text: "<=",
            rule: 5
        },
        {
            text: "!=",
            rule: 6
        },
        {
            text: $t("cloudpivot.all.包含"),
            rule: 7
        },
        {
            text: $t("cloudpivot.all.不包含"),
            rule: 8
        }
    ],
    userAttributes: [
        {
            name: $t("cloudpivot.all.主部门"),
            mark: "departments",
            type: 0
        },
        {
            name: $t("cloudpivot.all.兼职部门"),
            mark: "partTimerDepartment",
            type: 0
        },
        {
            name: $t("cloudpivot.all.主管"),
            mark: "manager",
            type: 0
        },
        // {
        //   name: '兼职部门',
        //   mark: '$departmentName',
        //   type: 0
        // },
        // {
        //   name: "秘书",
        //   mark: "secretary",
        //   type: 0
        // },
        // {
        //   name: '用户账号',
        //   mark: 'accountId',
        //   type: 1
        // },
        // {
        //   name: '用户名称',
        //   mark: 'accountUsername',
        //   type: 1
        // },
        {
            name: $t("cloudpivot.all.角色"),
            mark: "roleName",
            type: 1
        },
        // {
        //   name: "身份证号",
        //   mark: "identityNo",
        //   type: 1
        // },
        {
            name: $t("cloudpivot.all.办公电话"),
            mark: "officePhone",
            type: 1
        },
        {
            name: $t("cloudpivot.all.手机号"),
            mark: "mobile",
            type: 1
        },
        {
            name: $t("cloudpivot.all.邮箱"),
            mark: "email",
            type: 1
        },
        {
            name: $t("cloudpivot.all.员工编号"),
            mark: "employeeNo",
            type: 1
        },
        // {
        //   name: "职级",
        //   mark: "employeeRank",
        //   type: 1
        // },
        // {
        //   name: "称谓",
        //   mark: "appellation",
        //   type: 1
        // },
        // {
        //   name: '钉钉',
        //   mark: 'userId',
        //   type: 1
        // },
        // {
        //   name: "出生日期",
        //   mark: "birthday",
        //   type: 2
        // },
        {
            name: $t("cloudpivot.all.入职日期"),
            mark: "entryDate",
            type: 2
        },
    ],
    /**
     * 对应选人控件数据项
     */
    attributesUserSelection: [
        /* {
          name: '所属机构',
          mark: 'departments'
        }, */
        {
            name: $t("cloudpivot.all.主部门"),
            mark: "departments"
        },
        {
            name: $t("cloudpivot.all.兼职部门"),
            mark: "partTimerDepartment"
        },
        {
            name: $t("cloudpivot.all.主管"),
            mark: "manager"
        },
        {
            name: $t("cloudpivot.all.秘书"),
            mark: "secretary"
        }
    ],
    /**
     * 文本型数据项
     */
    attributesText: [
        {
            name: $t("cloudpivot.all.用户账号"),
            mark: "accountId"
        },
        {
            name: $t("cloudpivot.all.用户名称"),
            mark: "name"
        },
        {
            name: $t("cloudpivot.all.角色"),
            mark: "roleName"
        },
        {
            name: $t("cloudpivot.all.身份证号"),
            mark: "identityNo"
        },
        {
            name: $t("cloudpivot.all.办公电话"),
            mark: "officePhone"
        },
        {
            name: $t("cloudpivot.all.手机号"),
            mark: "mobile"
        },
        {
            name: $t("cloudpivot.all.邮箱"),
            mark: "email"
        },
        {
            name: $t("cloudpivot.all.员工编号"),
            mark: "employeeNo"
        },
        {
            name: $t("cloudpivot.all.职级"),
            mark: "employeeRank"
        },
        {
            name: $t("cloudpivot.all.称谓"),
            mark: "appellation"
        },
        {
            name: $t("cloudpivot.all.钉钉"),
            mark: "userId"
        }
    ],
    /**
     * 日期类型属性
     */
    attributesDate: [
        {
            name: $t("cloudpivot.all.出生日期"),
            mark: "birthday"
        },
        {
            name: $t("cloudpivot.all.入职日期"),
            mark: "entryDate"
        },
        {
            name: $t("cloudpivot.all.离职日期"),
            mark: "departureDate"
        }
    ],
    defaultRegularList: [
        // {
        //   text:'无模板', 正则表达式规则 不需要无模版 类型
        //   rule:''
        // },
        {
            text: $t("cloudpivot.all.请输入一个整数"),
            rule: "/^(-|\\+)?(\\d)*$/",
            en: "Please enter an integer"
        },
        {
            text: $t("cloudpivot.all.请输入一个数字"),
            rule: "/^[\\+\\-]?\\d*?\\.?\\d*?$/",
            en: "Please enter a number"
        },
        {
            text: $t("cloudpivot.all.请输入一个有效邮箱地址"),
            rule: "/^\\w+([-+.]\\w+)*@\\w+([-.]\\\\w+)*\\.\\w+([-.]\\w+)*$/",
            en: "Please enter a valid email address"
        },
        {
            text: $t("cloudpivot.all.请输入一个有效手机号码"),
            rule: "/^1[3|4|5|6|7|8|9][0-9]{9}$/",
            en: "Please enter a valid mobile phone number"
        },
        {
            text: $t("cloudpivot.all.请输入一个有效的电话号码"),
            rule: "/^0\\d{2,3}-?\\d{7,8}$/",
            en: "Please enter a valid telephone number"
        },
        {
            text: $t("cloudpivot.all.请输入一个有效的邮编"),
            rule: "/^[1-9]\\d{5}(?!\\d)$/",
            en: "Please enter a valid zip code"
        },
        {
            text: $t("cloudpivot.all.请输入一个有效的身份证"),
            rule: "/^(\\d{6})(\\d{4})(\\d{2})(\\d{2})(\\d{3})([0-9]|X)$/",
            en: "Please enter a valid ID card"
        },
        {
            text: $t("cloudpivot.all.请输入中文字符"),
            rule: "/^[\\u4e00-\\u9fa5]+$/",
            en: "Please enter Chinese characters"
        },
        {
            text: $t("cloudpivot.all.自定义"),
            rule: "xx",
            en: ""
        }
    ]
};
export default optionsMap;
